// @ts-ignore
import CountryNames from "@/libs/i18nCountryNames";
// @ts-ignore
import store from "@/store";

export const getCountriesAsArray = (): Array<{
    code: string;
    name: string;
}> => {
    return Object.entries(CountryNames.getNames(store.state.appConfig.language)).map(([code, name]) => ({
        code,
        name,
    }));
};

export const getCountryName = (country: string): string => {
    return CountryNames.getName(country, store.state.appConfig.language);
};
